import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { useAuth } from "../lib/auth";
import { errMsg } from "../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try { await login(email, password); nav("/"); } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#0A0A0A] text-white p-12">
        <div className="font-head text-xl font-bold">SALES RESCUE<span className="text-[#4D7CFF]"> AI</span></div>
        <div>
          <div className="eyebrow !text-neutral-400">Elaborazione locale · nessuna API a pagamento</div>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mt-4 leading-tight max-w-lg">Ritrova i clienti interessati che il predictive ha perso.</h1>
          <p className="text-neutral-400 mt-4 max-w-md text-sm">Registrazioni AlFa Dial, trascrizione faster-whisper e classificazione Ollama, interamente sul tuo server.</p>
        </div>
        <div className="text-xs text-neutral-500 font-mono">Accesso riservato al Super Amministratore</div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-4" data-testid="login-form">
          <div>
            <h2 className="text-2xl font-semibold tracking-tight">Accesso</h2>
            <p className="text-sm text-neutral-500 mt-1">Inserisci le credenziali del Super Amministratore.</p>
          </div>
          <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-10 rounded-sm" data-testid="login-email-input" required />
          <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-10 rounded-sm" data-testid="login-password-input" required />
          {err && <div className="text-sm text-red-700" data-testid="login-error">{err}</div>}
          <Button type="submit" disabled={busy} className="w-full h-10 rounded-sm bg-[#0047FF] hover:bg-[#0039cc]" data-testid="login-submit-button">
            {busy ? "Accesso…" : "Accedi"}
          </Button>
        </form>
      </div>
    </div>
  );
}
